module.exports = __webpack_public_path__ + "images/emoji/aries.fd4dd4a9e2f928194a36.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/aries.png
// module id = 9A4F
// module chunks = 14